function openChat(): void {
  Genesys('command', 'Messenger.open')
}
export const chatService = {
  openChat
}
